<template>
    <div>
        <o-table :title="$t('sandoz.kickout_reports_' + $route.meta.list_type)" ref="tableList" :url="'/api/sandoz/wholesaler_kickout_report?include=localkey&filter[hide_ignores]=1&filter[list_type]=' + $route.meta.list_type"
                 :enable-new="false" :enable-edit="false" :enable-delete="false">
            <template slot="filter">
                <div class="row">
                    <div class="col">
                        <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                            <o-filter-monthpicker :title="$t('sandoz.year_month')" column="year_month"></o-filter-monthpicker>
                            <o-filter-select :title="$t('sandoz.year')" column="year" :items="years"></o-filter-select>
                            <o-filter-text :title="$t('sandoz.whs_customer_name')" column="whs_customer_name" :prepend-percentage="true"></o-filter-text>
                            <o-filter-text :title="$t('sandoz.whs_customer_code')" column="whs_customer_code"></o-filter-text>
                            <o-filter-text :title="$t('sandoz.wholesaler_code')" column="wholesaler_code"></o-filter-text>
                            <o-filter-text  v-if="$route.meta.list_type != 'blacklist'" :title="$t('sandoz.reportname')" column="reportname"></o-filter-text>
                            <o-filter-text  v-if="$route.meta.list_type != 'blacklist'" :title="$t('sandoz.reportcode')" column="reportcode"></o-filter-text>
                            <o-filter-text :title="$t('sandoz.whs_customer_zip')" column="localkey_zip"></o-filter-text>
                            <o-filter-text  v-if="$route.meta.list_type != 'blacklist'" :title="$t('sandoz.reason')" column="reason"></o-filter-text>
                            <o-filter-text :title="$t('sandoz.whs_customer_localkey')" column="whs_customer_localkey"></o-filter-text>
                        </o-filter>
                    </div>
                    <div class="col text-right" style="flex: 0 0 200px;">
                        <o-button @click="excelReport" :loading="loading">
                            {{ $t('sandoz.download') }}
                        </o-button>
                    </div>
                </div>
            </template>
            <template slot="head">
                <o-table-header column="year_month">{{$t('sandoz.year_month')}}</o-table-header>
                <o-table-header column="whs_ean">{{$t('sandoz.whs_ean')}}</o-table-header>
                <o-table-header column="whs_customer_name">{{$t('sandoz.whs_customer_name')}}</o-table-header>
                <o-table-header column="whs_customer_code">{{$t('sandoz.whs_customer_code')}}</o-table-header>
                <o-table-header column="whs_customer_localkey">{{$t('sandoz.whs_customer_localkey')}}</o-table-header>
                <o-table-header column="wholesaler_code">{{$t('sandoz.wholesaler_code')}}</o-table-header>
                <o-table-header column="value">{{$t('sandoz.value')}}</o-table-header>
                <o-table-header column="reason" v-if="$route.meta.list_type != 'blacklist'">{{$t('sandoz.reason')}}</o-table-header>
                <o-table-header column="reportname" v-if="$route.meta.list_type != 'blacklist'">{{$t('sandoz.reportname')}}</o-table-header>
                <o-table-header column="reportcode" v-if="$route.meta.list_type != 'blacklist'">{{$t('sandoz.reportcode')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.whs_customer_address')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.whs_customer_zip')}}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{ props.item.year_month }}</td>
                <td>{{ props.item.whs_ean }}</td>
                <td>{{ props.item.whs_customer_name }}</td>
                <td>{{ props.item.whs_customer_code }}</td>
                <td><o-text-preview>{{ props.item.whs_customer_localkey }}</o-text-preview></td>
                <td><o-text-preview>{{ props.item.wholesaler_code }}</o-text-preview></td>
                <td>{{ props.item.value }}</td>
                <td v-if="$route.meta.list_type != 'blacklist'">{{ props.item.reason }}</td>
                <td v-if="$route.meta.list_type != 'blacklist'">{{ props.item.reportname }}</td>
                <td v-if="$route.meta.list_type != 'blacklist'">{{ props.item.reportcode }}</td>
                <td>{{ props.item.localkey && props.item.localkey.data ? props.item.localkey.data.whs_customer_address : '' }}</td>
                <td>{{ props.item.localkey && props.item.localkey.data ? props.item.localkey.data.whs_customer_zip : '' }}</td>
            </template>
            <template slot="body-controls" slot-scope="props">
                <td class="text-right">
                    <div class="d-flex">
                        <o-button variant="outline-secondary" @click.prevent="ignoreRecord(props.item)" class="mr-1">
                            <fa icon="times"/>
                        </o-button>
                        <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                            <fa icon="arrow-right"/>
                        </router-link>
                    </div>
                </td>
            </template>
        </o-table>
        <o-action-toolbar>
            <div class="d-flex w-100">
                <o-button variant="outline-primary" @click.prevent="back">{{$t('core.back')}}</o-button>
            </div>
        </o-action-toolbar>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        loading: false
    }),
    computed: {
        years() {
            const currentYear = new Date().getFullYear()
            const years = []
            for (let i = currentYear + 1; i >= 2018; i--) {
                years.push({value: i, text: i})
            }
            return years
        }
    },
    mounted() {
    },
    methods: {
        ignoreRecord(item) {
            var self = this
            if (window.confirm('Are you sure you want to ignore this record?')) {
                axios.post('/api/sandoz/wholesaler_kickout_ignores/new', item).then((response) => {
                    self.$refs.tableList.search()
                })
                //
            }
            //window.alert(JSON.stringify(item))
        },
        back() {
            this.$router.back()
        },
        excelReport() {
            const filters = this.$refs.tableList ? this.$refs.tableList.filters : {}
            const params = new URLSearchParams()

            // always include base filters from the route
            params.append('filter[hide_ignores]', '1')
            params.append('filter[list_type]', this.$route.meta.list_type)

            // include user-applied filters
            if (filters) {
                Object.keys(filters).forEach(key => {
                    if (filters[key]) {
                        params.append('filter[' + key + ']', filters[key])
                    }
                })
            }

            const headers = {
                'accept': 'application/vnd.ms-excel'
            }

            this.loading = true

            axios({
                method: 'GET',
                url: '/api/sandoz/wholesaler_kickout_report/excel?' + params.toString(),
                responseType: 'blob',
                headers: headers
            }).then((response) => {
                var filename = 'kickout_report.xlsx'
                var contentDisposition = response.headers['content-disposition']
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                    var matches = filenameRegex.exec(contentDisposition)
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '')
                    }
                }

                require('downloadjs')(response.data, filename, headers.accept)
                this.loading = false
            })
            .catch((err) => {
                this.$notify({
                    title: this.$i18n.t('core.error'),
                    text: this.$i18n.t('core.error_text', {error: err}),
                    type: 'error'
                })

                this.loading = false
            })
        }
    }
}
</script>
